module.exports = __webpack_public_path__ + "img/man.77b24123.png";